import React from "react";
import { useState } from "react";
import AddLead from "./Modals/AddLead";

function Footer() {
  const [show, setShow] = useState("");

  const handleShow = () => {
    setShow(!show);
  };

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="widget text-white">
              <h3>About Us</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor. Aenean massa.
              </p>
              <p>
                pellentesque eu, pretium quis, sem. Nulla consequat massa quis
                enim
              </p>
              <span className="orLog">
                <img src="assets/images/Facebook.png" alt="" className="me-2" />
                <img
                  src="assets/images/Instagram.png"
                  alt=""
                  className="me-2"
                />
                <img src="assets/images/Linkedin.png" alt="" className="me-2" />
                <img src="assets/images/Twitter.png" alt="" />
              </span>
            </div>
          </div>
          {/* <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="widget">
              <h3>Our Services</h3>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <ul className="footer-li">
                    <li>
                      <Link to="/">Architectural</Link>
                    </li>
                    <li>
                      <Link to="/">Electrical</Link>
                    </li>
                    <li>
                      <Link to="/">Mechanical</Link>
                    </li>
                    <li>
                      <Link to="/">Curtains and Blinds</Link>
                    </li>
                    <li>
                      <Link to="/">Anti Slip Floor Solution Treatment</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="widget">
              <h3>Latest News</h3>
              <div className="newFlex">
                <img
                  src="assets/images/dummy.png"
                  alt=""
                  className="newImege"
                />
                <div>
                  <p className="mb-0">Lorem ipsum dolor sit amet,</p>
                  <small>Jan 12, 2023</small>
                </div>
              </div>
              <div className="newFlex">
                <img
                  src="assets/images/dummy.png"
                  alt=""
                  className="newImege"
                />
                <div>
                  <p className="mb-0">Lorem ipsum dolor sit amet,</p>
                  <small>Jan 12, 2023</small>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="widget">
              <h3>Contact us</h3>
              <p className="position-relative ps-4 text-white">
                <img
                  src="assets/images/Address.png"
                  alt=""
                  className="footerImg"
                />
                DieSachbearbeiterChoriner Straße 49 10435 Berlin
              </p>
              <p className="position-relative ps-4 text-white">
                <img
                  src="assets/images/call.png"
                  alt=""
                  className="footerImg"
                />
                +91-8005214320{" "}
              </p>

              <p className="position-relative ps-4 text-white">
                <img
                  src="assets/images/Emailfooter.png"
                  alt=""
                  className="footerImg"
                />
                houzez@gmail.com{" "}
              </p>
            </div>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 mt-5 text-center fw-bold text-white">
            &copy; 2023 Houzez. All right Reserved
          </div>
        </div>
      </div>
      <img
        src="assets/images/Chat.png"
        alt=""
        className="chatIcon"
        // onClick={() => {
        //   handleShow();
        // }}
      />
      <AddLead show={show} handleShow={handleShow} />
    </footer>
  );
}

export default Footer;
